var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nutritionist"},[_c('img',{attrs:{"src":"https://cdn-file.xiaojudai.cn/static/common/images/nutritionistBack2.jpg"}}),_c('a',{staticClass:"goNutritionist",attrs:{"href":"https://work.weixin.qq.com/ca/cawcde922f90d12f35"}},[_c('img',{attrs:{"src":"https://cdn-file.xiaojudai.cn/static/common/images/goNutritionist2.png"}})])])
}]

export { render, staticRenderFns }